var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 19.8438C15.2118 19.8438 14.2656 20.79 14.2656 21.9531V27.6719C14.2656 28.835 15.2118 29.7812 16.375 29.7812C17.5382 29.7812 18.4844 28.835 18.4844 27.6719V21.9531C18.4844 20.79 17.5382 19.8438 16.375 19.8438Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 21.9531C12.8594 21.7503 12.8861 21.5544 12.9193 21.3609C12.0719 21.6348 11.4531 22.4219 11.4531 23.3594V26.2656C11.4531 27.2031 12.0719 27.9902 12.9193 28.2641C12.8861 28.0706 12.8594 27.8747 12.8594 27.6719V21.9531Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 19.8438C26.4618 19.8438 25.5156 20.79 25.5156 21.9531V27.6719C25.5156 28.835 26.4618 29.7812 27.625 29.7812C27.8364 29.7812 28.0367 29.7406 28.2293 29.6824C27.9676 30.55 27.1705 31.1875 26.2188 31.1875H23.9799C23.6886 30.3708 22.9155 29.7812 22 29.7812C20.8368 29.7812 19.8906 30.7275 19.8906 31.8906C19.8906 33.0538 20.8368 34 22 34C22.9155 34 23.6886 33.4104 23.9799 32.5938H26.2188C28.1572 32.5938 29.7344 31.0165 29.7344 29.0781V27.6719V21.9531C29.7344 20.79 28.7882 19.8438 27.625 19.8438Z",
    fill: "#4B9BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0806 21.3609C31.1137 21.5544 31.1405 21.7503 31.1405 21.9531V27.6719C31.1405 27.8747 31.1137 28.0706 31.0806 28.2641C31.928 27.9902 32.5467 27.2031 32.5467 26.2656V23.3594C32.5467 22.4219 31.928 21.6348 31.0806 21.3609Z",
    fill: "#4B9BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10C16.1841 10 11.4531 14.731 11.4531 20.5469V20.5648C11.872 20.2477 12.3567 20.0156 12.8916 19.9117C13.2202 15.168 17.1744 11.4062 22 11.4062C26.8256 11.4062 30.7798 15.168 31.1084 19.9116C31.6432 20.0155 32.1279 20.2477 32.5469 20.5648V20.5469C32.5469 14.731 27.8159 10 22 10Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.2e3223967f88435555464baf932ab002.svg";
export { ForwardRef as ReactComponent };